import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DepartureCheckService {

    api_url = environment.url;

    constructor(private http: HttpClient) { }

    listPending(params: any = {}) {
        const cleanParams: any = {};
        Object.keys(params || {}).forEach((key) => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                cleanParams[key] = String(value);
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        return this.http.get(`${this.api_url}unit/departure-checks/pending${queryString ? '?' + queryString : ''}`);
    }

    startCheck(serviceId: number) {
        return this.http.post(`${this.api_url}unit/departure-checks`, { service_id: serviceId });
    }

    getCheck(id: number) {
        return this.http.get(`${this.api_url}unit/departure-checks/${id}`);
    }

    updateStep(id: number, step: number) {
        return this.http.put(`${this.api_url}unit/departure-checks/${id}/step`, { current_step: step });
    }

    updateServicio(id: number, data: any) {
        return this.http.put(`${this.api_url}unit/departure-checks/${id}/servicio`, data);
    }

    updateDamage(id: number, data: any) {
        return this.http.put(`${this.api_url}unit/departure-checks/${id}/damage`, data);
    }

    updateFuncionamiento(id: number, data: any) {
        return this.http.put(`${this.api_url}unit/departure-checks/${id}/funcionamiento`, data);
    }

    updateTablero(id: number, data: any, odometerPhoto?: File) {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            const value = data[key];
            if (value === null || value === undefined) return;
            if (Array.isArray(value)) {
                value.forEach(v => formData.append(`${key}[]`, v));
            } else {
                formData.append(key, value);
            }
        });
        if (odometerPhoto) {
            formData.append('odometer_photo', odometerPhoto);
        }
        return this.http.post(`${this.api_url}unit/departure-checks/${id}/tablero`, formData);
    }

    updateFotos(id: number, photos: Record<string, File>) {
        const formData = new FormData();
        Object.keys(photos).forEach(categoria => {
            formData.append(`photos[${categoria}]`, photos[categoria]);
        });
        return this.http.post(`${this.api_url}unit/departure-checks/${id}/fotos`, formData);
    }

    updateDocumentos(id: number, data: any) {
        return this.http.put(`${this.api_url}unit/departure-checks/${id}/documentos`, data);
    }

    complete(id: number, generalObservations: string) {
        return this.http.post(`${this.api_url}unit/departure-checks/${id}/complete`, { general_observations: generalObservations });
    }

    requestUpdate(id: number, generalObservations: string) {
        return this.http.post(`${this.api_url}unit/departure-checks/${id}/request-update`, { general_observations: generalObservations });
    }

    downloadPdf(id: number): Observable<Blob> {
        return this.http.get(`${this.api_url}unit/departure-checks/${id}/pdf`, { responseType: 'blob' });
    }
}
